import { getSocketClient, subscribe, unSubscribeAll } from '@G/api/socket'
// import { Subscriptions as Feedbacks } from '@G/api/graphql/Feedbacks'
import { SubscribeEvents } from '@GUTIL/hardCode'

const eventGqlMap = {
  // [SubscribeEvents.SUBSCRIBE_FEEDBACK]: Feedbacks.subscribeFeedback
}

let socketApolloClient = null,
  socketSubscriptionClient = null

const state = {
  subscribeEvents: [], // value: event
  subscribeResponse: {} // key: event,  value: response
}

const actions = {
  async [_GM.SUBSCRIBE_SOCKET]({ commit, state }, event) {
    // 檢查 client 是否建立
    if (!socketApolloClient || !socketSubscriptionClient) {
      let { apolloClient, subscriptionClient } = getSocketClient()
      socketApolloClient = apolloClient
      socketSubscriptionClient = subscriptionClient
    }
    // 尚未註冊事件
    if (state.subscribeEvents.indexOf(event) < 0) {
      let callback = data => {
        commit(_GM.SET_SUBSCRIBE_RESPONSE, { event, response: data })
      }
      subscribe(socketApolloClient, eventGqlMap[event], callback)
      commit(_GM.SET_SUBSCRIBE_EVENTS, event)
    }
  },
  async [_GM.UNSUBSCRIBE_SOCKET]({ commit }) {
    if (socketApolloClient && socketSubscriptionClient) {
      unSubscribeAll(socketSubscriptionClient)
      commit(_GM.CLOSE_SOCKET)
    }
  }
}

const mutations = {
  [_GM.SET_SUBSCRIBE_EVENTS](state, event) {
    state.subscribeEvents.push(event)
  },
  [_GM.SET_SUBSCRIBE_RESPONSE](state, { event, response }) {
    state.subscribeResponse = { ...state.subscribeResponse, [event]: response }
  },
  [_GM.CLOSE_SOCKET](state) {
    socketApolloClient = null
    socketSubscriptionClient = null
    state.subscribeEvents = []
    state.subscribeResponse = {}
  }
}

const getters = {
  subscribeResponse: state => state.subscribeResponse
}

export default {
  state,
  actions,
  mutations,
  getters
}
